var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-avatar',{staticClass:"badge-minimal",attrs:{"size":"40","src":_vm.userData,"variant":"light-primary","badge":"","badge-variant":"success"}},[(!_vm.userData)?_c('feather-icon',{attrs:{"icon":"UserIcon","size":"22"}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }